{
  "metadata": {
    "id": "everforest-dark",
    "name": "Everforest",
    "description": "Портировано из темы «Everforest» (dark)",
    "author": "OpenCode",
    "version": "2.0.0",
    "variant": "dark",
    "tags": [
      "dark",
      "ported"
    ],
    "source": {
      "file": "everforest.json",
      "project": "sainnhe",
      "url": "https://github.com/sainnhe/everforest",
      "upstreamFile": "packages/ui/src/theme/themes/everforest.json",
      "license": "MIT",
      "authoring": null
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 22.7,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.329,
      "paletteMaxS": 0.387,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 4.1,
      "surfacesTarget": 4.0,
      "surfacesRaisedTarget": 5.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 21.0,
      "syntaxVsTextMinDeltaE": 14.8,
      "chartsMinDeltaE": 23.4,
      "textSeparationDeltaE": 13.3,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [
        {
          "a": "string",
          "b": "function",
          "deltaE": 15.9
        },
        {
          "a": "string",
          "b": "operator",
          "deltaE": 15.9
        },
        {
          "a": "function",
          "b": "operator",
          "deltaE": 0.0
        }
      ],
      "modeLabel": "dark",
      "modeFromLuminance": "dark",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#a7c080",
      "hover": "#b2c88f",
      "active": "#b9cd99",
      "foreground": "#000000",
      "muted": "#a7c08080",
      "emphasis": "#a7c080"
    },
    "surface": {
      "background": "#2d353b",
      "foreground": "#d3c6aa",
      "muted": "#414749",
      "mutedForeground": "#bdc2bb",
      "elevated": "#4b5050",
      "elevatedForeground": "#d3c6aa",
      "raised": "#636560",
      "raisedForeground": "#e8e1d2",
      "overlay": "#2d353bcc",
      "subtle": "#373e42"
    },
    "interactive": {
      "border": "#696a64",
      "borderHover": "#5b5e5a",
      "borderFocus": "#a7c080",
      "selection": "#d3c6aa29",
      "selectionForeground": "#d3c6aa",
      "focus": "#a7c08059",
      "focusRing": "#a7c08061",
      "cursor": "#d3c6aa",
      "hover": "#d3c6aa1c",
      "active": "#d3c6aa29"
    },
    "status": {
      "error": "#e67e80",
      "errorForeground": "#000000",
      "errorBackground": "#e67e8024",
      "errorBorder": "#e67e8073",
      "warning": "#e69875",
      "warningForeground": "#000000",
      "warningBackground": "#e6987524",
      "warningBorder": "#e6987573",
      "success": "#a7c080",
      "successForeground": "#000000",
      "successBackground": "#a7c08024",
      "successBorder": "#a7c08073",
      "info": "#83c092",
      "infoForeground": "#000000",
      "infoBackground": "#83c09224",
      "infoBorder": "#83c09273"
    },
    "pr": {
      "open": "#a7c080",
      "draft": "#cccfcb",
      "blocked": "#e69875",
      "merged": "#d699b6",
      "closed": "#e67e80"
    },
    "syntax": {
      "base": {
        "background": "#545857",
        "foreground": "#d3c6aa",
        "comment": "#cfdce2",
        "keyword": "#e8c5d5",
        "string": "#c1d3a5",
        "number": "#f1c5b1",
        "function": "#afd6b9",
        "variable": "#f3c2c3",
        "type": "#e9c98c",
        "operator": "#afd6b9"
      },
      "tokens": {
        "commentDoc": "#cfdce2",
        "stringEscape": "#afd6b9",
        "keywordImport": "#e8c5d5",
        "storageModifier": "#e8c5d5",
        "functionCall": "#afd6b9",
        "method": "#afd6b9",
        "variableProperty": "#afd6b9",
        "variableOther": "#f3c2c3",
        "variableGlobal": "#f1c5b1",
        "variableLocal": "#afd6b9",
        "parameter": "#f3c2c3",
        "constant": "#f1c5b1",
        "class": "#e9c98c",
        "className": "#e9c98c",
        "interface": "#e9c98c",
        "struct": "#e9c98c",
        "enum": "#e9c98c",
        "typeParameter": "#e9c98c",
        "namespace": "#e9c98c",
        "module": "#e8c5d5",
        "tag": "#e8c5d5",
        "jsxTag": "#e8c5d5",
        "tagAttribute": "#afd6b9",
        "tagAttributeValue": "#c1d3a5",
        "boolean": "#f1c5b1",
        "decorator": "#e8c5d5",
        "label": "#afd6b9",
        "regexp": "#c1d3a5"
      }
    },
    "charts": {
      "series": [
        "#a7c080",
        "#83c0a6",
        "#73c255",
        "#e69875",
        "#e1bcac"
      ]
    },
    "chat": {
      "background": "#2d353b",
      "userMessage": "#efeae0",
      "userMessageBackground": "#4b5050",
      "assistantMessage": "#d8cdb4",
      "assistantMessageBackground": "#414749",
      "timestamp": "#cccfcb",
      "divider": "#696a64",
      "typing": "#cccfcb"
    },
    "loading": {
      "spinner": "#a7c080",
      "spinnerTrack": "#414749",
      "skeleton": "#414749",
      "shimmer": "#5c5f5c"
    },
    "tools": {
      "background": "#414749",
      "border": "#696a64",
      "headerHover": "#5a5e5b",
      "icon": "#a7c080",
      "title": "#d3c6aa",
      "description": "#cccfcb",
      "edit": {
        "added": "#a7c080",
        "addedBackground": "#a7c08024",
        "removed": "#e67e80",
        "removedBackground": "#e67e8024",
        "modified": "#83c092",
        "modifiedBackground": "#83c09224",
        "lineNumber": "#cccfcb"
      }
    },
    "markdown": {
      "heading1": "#d3c6aa",
      "heading2": "#d3c6aa",
      "heading3": "#d3c6aa",
      "heading4": "#d3c6aa",
      "link": "#a7c080",
      "linkHover": "#b2c88f",
      "inlineCode": "#c1d3a5",
      "inlineCodeBackground": "#414749",
      "blockquote": "#cccfcb",
      "blockquoteBorder": "#696a64",
      "listMarker": "#a7c080bf",
      "bold": "#d3c6aa",
      "italic": "#d3c6aae6",
      "strikethrough": "#cccfcb",
      "hr": "#696a64"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#d8aaa9",
        "foreground": "#000000",
        "contrast": 10.24
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#af6a51",
        "foreground": "#000000",
        "contrast": 5.0
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#a18e64",
        "foreground": "#000000",
        "contrast": 6.57
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#d1ce97",
        "foreground": "#000000",
        "contrast": 12.99
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#88a862",
        "foreground": "#000000",
        "contrast": 7.82
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#5ab45a",
        "foreground": "#000000",
        "contrast": 8.11
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#b4d2c1",
        "foreground": "#000000",
        "contrast": 12.93
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#70be97",
        "foreground": "#000000",
        "contrast": 9.5
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#66a0a2",
        "foreground": "#000000",
        "contrast": 7.12
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#607e9e",
        "foreground": "#000000",
        "contrast": 4.98
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#a9b7d7",
        "foreground": "#000000",
        "contrast": 10.44
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#504daa",
        "foreground": "#ffffff",
        "contrast": 7.04
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#836fae",
        "foreground": "#000000",
        "contrast": 4.85
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#af53ab",
        "foreground": "#ffffff",
        "contrast": 4.52
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#cc92c2",
        "foreground": "#000000",
        "contrast": 8.46
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#ae5164",
        "foreground": "#ffffff",
        "contrast": 5.05
      }
    ]
  }
}
